import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomRFIDisplayStatus } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import {
  RFI_DISPLAY_STATUS_LABEL_KEYS,
  RFI_DISPLAY_STATUS_COLOR,
} from '../RfiRequestsTable/utils';

import './RfiStatusTag.styles.scss';

type RfiStatusTagProps = {
  className?: string;
  status: DataRoomRFIDisplayStatus;
};

const RfiStatusTag: React.FC<RfiStatusTagProps> = (props) => {
  const { className, status } = props;

  const classes = classNames(
    'rfi-status-tag',
    RFI_DISPLAY_STATUS_COLOR[status],
    className,
  );

  const { t } = useTranslation();

  return <span className={classes}>{t(RFI_DISPLAY_STATUS_LABEL_KEYS[status])}</span>;
};

export default RfiStatusTag;
